import { SectionCatalogProps } from '@sbercloud/uikit-product-site-section';
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime';

import { ClickAnalyticsType } from '../../../../../types';

type CreateFooterLinks = {
  allProductsLength: number;
  allSolutionsLength: number;
  clickAnalytics: (variables: ClickAnalyticsType) => void;
  router: AppRouterInstance;
};

export function createFooterLinks({
  allProductsLength,
  allSolutionsLength,
  clickAnalytics,
  router,
}: CreateFooterLinks): SectionCatalogProps['footer'] {
  return [
    {
      label: `Все сервисы ${allProductsLength ? `(${allProductsLength})` : ''}`,
      href: '/products',
      onClick: (e) => {
        e.preventDefault();

        clickAnalytics({
          action: 'click',
          clickZone: 'body',
          clickElement: 'button',
          clickContent: 'Все сервисы',
          uniqueId: 'additional-links-products',
          transitionType: 'inside-link',
        });

        router.push('/products');
      },
    },
    {
      label: `Все решения ${
        allSolutionsLength ? `(${allSolutionsLength})` : ''
      }`,
      href: '/solutions',
      onClick: (e) => {
        e.preventDefault();

        clickAnalytics({
          action: 'click',
          clickZone: 'body',
          clickElement: 'button',
          clickContent: 'Все решения',
          uniqueId: 'additional-links-solutions',
          transitionType: 'inside-link',
        });

        router.push('/solutions');
      },
    },
    {
      label: 'Маркетплейс',
      href: '/marketplace',
      onClick: (e) => {
        e.preventDefault();

        clickAnalytics({
          action: '/marketplace',
          clickZone: 'body',
          clickElement: 'button',
          clickContent: 'Маркетплейс',
          uniqueId: 'additional-links-marketplace',
          transitionType: 'inside-link',
        });

        router.push('/marketplace');
      },
    },
  ];
}
